/**
 * CREDIA Logo component — Brand Book V4 "The Dot"
 * IBM Plex Sans Bold, -0.02em tracking
 * Flat text + orange dot circle + orange "pro"
 * Size variants: 48px (hero), 32px (page), 20px (in-app), 16px (nav min)
 * Brand rule: no .pro suffix below 20px
 */

import { clsx } from 'clsx';
import { Link } from 'react-router-dom';

export interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'hero';
  showPro?: boolean;
  linkTo?: string;
  className?: string;
}

const sizeStyles = {
  sm: 'text-[16px]',   // Nav minimum — no .pro below 20px
  md: 'text-[20px]',   // In-app header
  lg: 'text-[32px]',   // Page header
  hero: 'text-[48px]', // Landing page hero
};

export function Logo({ size = 'md', showPro = true, linkTo, className }: LogoProps) {
  // Brand book: no .pro suffix below 20px
  const shouldShowPro = showPro && size !== 'sm';

  const logoContent = (
    <span
      className={clsx(
        'logo-hover-lift font-bold tracking-[-0.02em] font-sans',
        sizeStyles[size],
        className
      )}
    >
      <span className="logo-text">Credia</span>
      {shouldShowPro && (
        <>
          <span className="logo-dot" aria-hidden="true" />
          <span className="logo-pro">pro</span>
        </>
      )}
    </span>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="inline-flex" aria-label="Credia home">
        {logoContent}
      </Link>
    );
  }

  return logoContent;
}
